import moment, { Moment } from 'moment';
import { getMomentDate } from '../../../Utils/dates.util';

export const checkIsTimeSameOrAfter = async (
	date: string | Moment,
	timeFrom: string | Moment,
	timeTo: string | Moment,
) => {
	const dateFrom = moment(date, 'HH:mm')
		.clone()
		.set({
			hour: getMomentDate(timeFrom).hour(),
			minute: getMomentDate(timeFrom).minute(),
			second: 0,
		});
	const dateTo = moment(date, 'HH:mm')
		.clone()
		.set({
			hour: getMomentDate(timeTo).hour(),
			minute: getMomentDate(timeTo).minute(),
			second: 0,
		});
	return dateTo.isSameOrAfter(dateFrom);
};

export const checkIsDateSameOrAfter = async (
	dateFrom: string | Moment,
	dateTo: string | Moment,
) => {
	const from = getMomentDate(dateFrom);
	const to = getMomentDate(dateTo);
	return to.isSameOrAfter(from);
};
